export default __webpack_public_path__ + "static/media/014-Washington Monument.557f7bf9.svg";